import Menu from "../Menu.js";
import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.UISettingsArea");
log.setLevel(log.levels.WARN);

const UISettingsArea = function () {
    $("#logs_font_size").hide();
    global.event_bus.subscribe("mode_switcher.switcher_left", ({mode}) => {
        if (mode === "logs") {
            $("#logs_font_size").css("display", null);
            $("#resource_size").hide();
        } else {
            $("#logs_font_size").hide();
            $("#resource_size").css("display", null);
        }
    });
};

global.app.bootstrap.register_module({
    name: "ui_ui_settings_area_menu",
    deps: ["dom_loaded"],
    init: async () => {
        Menu.create({
            name: "ui_settings_area",
            icon: "ui_settings",
            contents: ["#ui_size", "#resource_size", "#logs_font_size"],
            open_handler: () => {
                global.scene.disable_draggable_tools();
            },
            close_handler: () => {
                if (global.scene.objects.layers.media.ids.length > 0) {
                    global.scene.enable_draggable_tools();
                }
            },
            close_timer: true
        });
        $("#logs_font_size").hide();
    }
});

global.app.bootstrap.register_module({
    name: "ui_ui_settings_area_tools",
    deps: ["dom_loaded", "tools"],
    init: async () => {
        global.tools.register({
            name: "ui_plus",
            icon: "ui_plus f_mtac-icon-xlg",
            position: "#ui_size",
            handler: () => {
                if (global.app.scale.ku >= 1.2) {
                    return;
                }
                global.app.scale.wb = null;
                global.app.scale.ku += 0.1;
                global.configuration.app.ku = global.app.scale.ku;
                global.resources.update_scale();
                global.view.resize();
                global.configuration.commit_store("app");
                if (global.scene.map.loaded) {
                    global.scene.map.grid.draw();
                }
            }
        });

        global.tools.register({
            name: "ui_minus",
            icon: "ui_minus f_mtac-icon-xlg",
            position: "#ui_size",
            handler: () => {
                if (global.app.scale.ku <= 0.8) {
                    return;
                }
                global.app.scale.wb = null;
                global.app.scale.ku -= 0.1;
                global.configuration.app.ku = global.app.scale.ku;
                global.resources.update_scale();
                global.view.resize();
                global.configuration.commit_store("app");
                if (global.scene.map.loaded) {
                    global.scene.map.grid.draw();
                }
            }
        });

        global.tools.register({
            name: "ui_reset",
            icon: "refresh f_mtac-icon-xlg",
            position: "#ui_size",
            handler: () => {
                global.app.scale.wb = null;
                global.app.scale.ku = 1;
                global.configuration.app.ku = global.app.scale.ku;
                global.resources.update_scale();
                global.view.resize();
                global.configuration.commit_store("app");
                if (global.scene.map.loaded) {
                    global.scene.map.grid.draw();
                }
            }
        });

        global.tools.register({
            name: "resource_plus",
            icon: "resource_plus f_mtac-icon-xlg",
            position: "#resource_size",
            handler: () => {
                global.resources.scale_setting += 0.1;
                log.debug(`resource_plus scale_setting = ${global.resources.scale_setting}`);
                if (global.scene.map.is_gis === true) {
                    // dynamic resource size, depending on the zoom
                    global.view.ol_driver.update_resource_scale();
                } else {
                    global.resources.scale = global.resources.scale_setting;
                }

            }
        });

        global.tools.register({
            name: "resource_minus",
            icon: "resource_minus f_mtac-icon-xlg",
            position: "#resource_size",
            handler: () => {
                if (global.resources.scale_setting <= 0.1) {
                    return;
                }
                global.resources.scale_setting -= 0.1;

                if (global.scene.map.is_gis === true) {
                    // dynamic resource size, depending on the zoom
                    global.view.ol_driver.update_resource_scale();
                } else {
                    global.resources.scale = global.resources.scale_setting;
                }
            }
        });

        global.tools.register({
            name: "resource_reset",
            icon: "refresh f_mtac-icon-xlg",
            position: "#resource_size",
            handler: () => {
                global.resources.scale_reset();
            }
        });

        global.tools.register({
            name: "logs_font_plus",
            icon: "logs_font_plus f_mtac-icon-xlg",
            position: "#logs_font_size",
            handler: () => {
                global.app.scale.font_factor += 0.1;
                global.configuration.app.font_factor = global.app.scale.font_factor;
                global.configuration.commit_store("app");
            }
        });

        global.tools.register({
            name: "logs_font_minus",
            icon: "logs_font_minus f_mtac-icon-xlg",
            position: "#logs_font_size",
            handler: () => {
                global.app.scale.font_factor -= 0.1;
                global.configuration.app.font_factor = global.app.scale.font_factor;
                global.configuration.commit_store("app");
            }
        });

        global.tools.register({
            name: "logs_font_reset",
            icon: "refresh f_mtac-icon-xlg",
            position: "#logs_font_size",
            handler: () => {
                global.app.scale.font_factor = 1;
                global.configuration.app.font_factor = global.app.scale.font_factor;
                global.configuration.commit_store("app");
            }
        });
    }
});

export default new UISettingsArea();
